import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AnnouncementsService } from './api/announcements.service';
import { AttendanceService } from './api/attendance.service';
import { ChildPortfolioActivitiesService } from './api/childPortfolioActivities.service';
import { ChildPortfolioChildSkillStatsService } from './api/childPortfolioChildSkillStats.service';
import { ChildPortfolioChildTimelineService } from './api/childPortfolioChildTimeline.service';
import { ChildPortfolioChildrenService } from './api/childPortfolioChildren.service';
import { ChildPortfolioCompetenciesService } from './api/childPortfolioCompetencies.service';
import { ChildPortfolioKorabService } from './api/childPortfolioKorab.service';
import { ChildPortfolioLiteracyService } from './api/childPortfolioLiteracy.service';
import { ChildPortfolioNotesService } from './api/childPortfolioNotes.service';
import { ChildPortfolioRecordsService } from './api/childPortfolioRecords.service';
import { ChildPortfolioShipLogService } from './api/childPortfolioShipLog.service';
import { ChildPortfolioSkillAreasService } from './api/childPortfolioSkillAreas.service';
import { ChildPortfolioSkillProgressService } from './api/childPortfolioSkillProgress.service';
import { ChildPortfolioSkillsListService } from './api/childPortfolioSkillsList.service';
import { ChildPortfolioSkillsStatsService } from './api/childPortfolioSkillsStats.service';
import { ChildPortfolioStatisticsService } from './api/childPortfolioStatistics.service';
import { ChildPortfolioStatsService } from './api/childPortfolioStats.service';
import { ChildPortfolioWatchedService } from './api/childPortfolioWatched.service';
import { ChildrenService } from './api/children.service';
import { ChildrenGroupService } from './api/childrenGroup.service';
import { CitiesService } from './api/cities.service';
import { ClassesService } from './api/classes.service';
import { CloseRelativesService } from './api/closeRelatives.service';
import { ContractsService } from './api/contracts.service';
import { DayOffsService } from './api/dayOffs.service';
import { DistrictsService } from './api/districts.service';
import { DocumentsService } from './api/documents.service';
import { EEnrollmentService } from './api/eEnrollment.service';
import { EmailVerificationService } from './api/emailVerification.service';
import { EnrollmentTransferService } from './api/enrollmentTransfer.service';
import { ExportXmlService } from './api/exportXml.service';
import { GradeBookService } from './api/gradeBook.service';
import { GradeBookThematicBlocksService } from './api/gradeBookThematicBlocks.service';
import { InvitationsService } from './api/invitations.service';
import { KindergartenService } from './api/kindergarten.service';
import { KindergartenUsersService } from './api/kindergartenUsers.service';
import { LoggedTeacherService } from './api/loggedTeacher.service';
import { MSMTService } from './api/mSMT.service';
import { OrganizationService } from './api/organization.service';
import { PapCategoriesService } from './api/papCategories.service';
import { PhoneVerificationService } from './api/phoneVerification.service';
import { PortfolioService } from './api/portfolio.service';
import { RegistrationService } from './api/registration.service';
import { SpeechToTextService } from './api/speechToText.service';
import { SupportingMeasuresService } from './api/supportingMeasures.service';
import { SwitchDemoKindergartenService } from './api/switchDemoKindergarten.service';
import { TeacherInvitationsService } from './api/teacherInvitations.service';
import { TeacherResultsService } from './api/teacherResults.service';
import { TeachersService } from './api/teachers.service';
import { TransitionReportsService } from './api/transitionReports.service';
import { UnifiedChildHistoryService } from './api/unifiedChildHistory.service';
import { UnifiedGroupHistoryService } from './api/unifiedGroupHistory.service';
import { UsersService } from './api/users.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AnnouncementsService,
    AttendanceService,
    ChildPortfolioActivitiesService,
    ChildPortfolioChildSkillStatsService,
    ChildPortfolioChildTimelineService,
    ChildPortfolioChildrenService,
    ChildPortfolioCompetenciesService,
    ChildPortfolioKorabService,
    ChildPortfolioLiteracyService,
    ChildPortfolioNotesService,
    ChildPortfolioRecordsService,
    ChildPortfolioShipLogService,
    ChildPortfolioSkillAreasService,
    ChildPortfolioSkillProgressService,
    ChildPortfolioSkillsListService,
    ChildPortfolioSkillsStatsService,
    ChildPortfolioStatisticsService,
    ChildPortfolioStatsService,
    ChildPortfolioWatchedService,
    ChildrenService,
    ChildrenGroupService,
    CitiesService,
    ClassesService,
    CloseRelativesService,
    ContractsService,
    DayOffsService,
    DistrictsService,
    DocumentsService,
    EEnrollmentService,
    EmailVerificationService,
    EnrollmentTransferService,
    ExportXmlService,
    GradeBookService,
    GradeBookThematicBlocksService,
    InvitationsService,
    KindergartenService,
    KindergartenUsersService,
    LoggedTeacherService,
    MSMTService,
    OrganizationService,
    PapCategoriesService,
    PhoneVerificationService,
    PortfolioService,
    RegistrationService,
    SpeechToTextService,
    SupportingMeasuresService,
    SwitchDemoKindergartenService,
    TeacherInvitationsService,
    TeacherResultsService,
    TeachersService,
    TransitionReportsService,
    UnifiedChildHistoryService,
    UnifiedGroupHistoryService,
    UsersService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
